import { useMemo } from "react";
import _ from "lodash";

import { colors } from "theme/palette";
import { EMPTY_LIST } from "utils/constants";

import Box from "components/Box";
import FixedTable from "components/FixedTable";
import Stack from "components/Stack";
import Text from "components/Text";

import PrintableFieldTitle from "pages/PrintableChecklist/components/PrintableFieldTitle";

import { EFieldStatus } from "entities/Field/constants";
import { IField } from "entities/Field/sdk";

export interface IPrintableFixedTableField {
  field: IField;
}

const PrintableFixedTableField = ({ field }: IPrintableFixedTableField) => {
  const values = useMemo(
    () =>
      _.get(field.custom_values, "[0].column_value", EMPTY_LIST) as Array<any>,
    [field.custom_values]
  );

  if (!field.header_name) {
    return null;
  }

  return (
    <>
      <Stack
        id={field.field_id.toString()}
        direction="row"
        justifyContent="space-between"
        alignItems="flex-start"
        spacing={2}
        sx={{
          padding: 0.5,
          borderBottom: `1px solid ${colors.blue20}`,
          backgroundColor: "initial",
        }}
      >
        <PrintableFieldTitle field={field} />
        <Stack alignItems="center" paddingTop={0.5}>
          {field.status === EFieldStatus.NA && (
            <Text sx={{ color: colors.gray60 }}>N/A</Text>
          )}
        </Stack>
      </Stack>
      {field.status !== EFieldStatus.NA && (
        <Box sx={{ paddingLeft: 6, marginY: 3 }}>
          <FixedTable
            rows={values}
            headers={field.header_name.map(({ headerName, field }) => ({
              label: headerName,
              key: field,
            }))}
            tableDataTestid={field.display_name}
          />
        </Box>
      )}
    </>
  );
};

export default PrintableFixedTableField;
